module.exports = {
    HOST: "https://server.mapli.st",
    PAY_LINK_MONTHLY: "https://buy.stripe.com/3cs6qMfcffP78mc8wA",
    PAY_LINK_YEARLY: "https://buy.stripe.com/5kA16s3tx8mF0TKeUZ",
    PAY_LINK_LIFETIME: "https://buy.stripe.com/cN202o4xBauN45W3ci",
    PRICE_MONTHLY: 3,
    PRICE_YEARLY: 2,
    PRICE_LIFETIME: 39,
};